import { ref, computed } from '@vue/composition-api'
import axios from '@/libs/axios'
import store from '@/store'

const selectedProposal = ref({})


export function BrowseProposal() {
    const loading = ref(false)
    const data = ref([])
    const totalData = ref(0)
    const showData = ref(0)

    async function browse(id = null, take = 10, skip = 0, searchWord = '', order = {by: null, val: 'asc'}, query = '' ) {
        let base = `/product-proposal/with.total/true`
        searchWord  = searchWord.trim()
        take = `/take/${take}`
        skip = `/skip/${skip}`
        let search = `${searchWord !== '' ? `/s/${searchWord}`: ''}`
        let orderBy = order.by ?  `/orderBy.${order.by}/${order.val}` : ``
        let withId = id ? `/id/${id}` : ``;
        let complete = base + withId + take + skip + search + orderBy + query
        loading.value = true
        return await axios.get(complete)
        .then( res => {
            data.value = res.data.data.records
            totalData.value = res.data.data.total
            showData.value = res.data.data.show
        })
        .catch( err => {
            console.error(err)
        })
        .finally(() => {
            loading.value = false
        })
    }

    return {
        loading,
        browse,
        data,
        totalData,
        showData,
        selectedProposal
    }
}

export function createProposal() {
    let base = `/product-proposal`
    const form = ref({
        user_name : '',
        product_kode: '',
        title : '',
        company_name : '',
        company_address : '',
        company_profile : '',
        pic_name : '',
        pic_jabatan : '',
        start_date : '',
        end_date : '',
        lingkup_pekerjaan : '',
        am_nik : '',
        am_name : '',
        am_jabatan : '',
        am_phone : '',
        am_email : '',
        penawaran_harga: null,
        lampiran: null,
    })
    const companyProfileToSend = computed(() => {
        if (form.value.company_profile === 'Yes') {
            return 1
        } else {
            return 0
        }
    })
    const formData = computed(() => {
        let fd = new FormData();
        fd.append('user_name', form.value.user_name)
        fd.append('product_kode', form.value.product_kode)
        fd.append('title', form.value.title)
        fd.append('company_name', form.value.company_name)
        fd.append('company_address', form.value.company_address)
        fd.append('company_profile', companyProfileToSend.value)
        fd.append('pic_name', form.value.pic_name)
        fd.append('pic_jabatan', form.value.pic_jabatan)
        fd.append('start_date', form.value.start_date)
        fd.append('end_date', form.value.end_date)
        fd.append('lingkup_pekerjaan', form.value.lingkup_pekerjaan)
        fd.append('am_nik', form.value.am_nik)
        fd.append('am_name', form.value.am_name)
        fd.append('am_jabatan', form.value.am_jabatan)
        fd.append('am_phone', form.value.am_phone)
        fd.append('am_email', form.value.am_email)
        fd.append('penawaran_harga', form.value.penawaran_harga)
        fd.append('lampiran', form.value.lampiran)
        return fd
    })
    const conf = computed(() => {
        return {
            ...store.getters['app/axiosConf'],
            url: base,
            data: formData.value
        }
    })
    const isLoading = ref(false)
    const create = async() => {
        isLoading.value = true
        return await axios(conf.value)
        .catch(err => console.error(err))
    }
    return {
        create,
        form,
        isLoading
    }
}
